import styled, { css } from 'styled-components/macro';

export const StyledTabList = styled.div`
  margin: 0;
  position: relative;
  z-index: 1;
  display: flex;
  width: 100%;

  button {
    margin-bottom: 0;
  }

  ${({ pillStyle }) =>
    pillStyle &&
    css`
      display: inline-flex;
      background: white;
      border: 1px solid #e5e7eb;
      border-radius: 6px;
      padding: 4px;
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
      margin: 0;
    `}
`;

export const TabBtn = styled.div`
  padding: 0;
  flex: 1;
  &:first-child {
    padding-left: 0;
  }

  /* Override for vertical tabs (non-pill style) */
  ${({ theme, ...props }) =>
    props.isVertical &&
    !props.isPillStyle &&
    css`
      flex: none;
      width: 100%;
      padding: 0;
      margin-bottom: 0;
    `}
`;

export const StyledTab = styled.button`
  font-size: var(--font-size-sm);
  line-height: 16px;
  font-weight: 700;
  text-transform: capitalize;
  color: var(--text-color-gray);
  position: relative;
  padding: 10px 0px;
  border-radius: 0px;
  border-bottom: 1px solid transparent;
  width: 100%;
  text-align: left;
  border: none;
  background: transparent;
  cursor: pointer;

  &:after {
    display: none;
    visibility: hidden;
    opacity: 0;
    transition: ease-in-out 0.5s;
    content: '';
    position: absolute;
    left: 50%;
    right: 0;
    bottom: 0;
    transform: translateX(-50%);
    height: 1px;
    width: 0;
    background: var(--secondary-text-color);
  }

  ${({ active }) =>
    active &&
    css`
      color: var(--black);
      border-bottom: 1px solid black;

      &:after {
        visibility: visible;
        opacity: 1;
        width: 100%;
      }
    `}

  ${({ pillStyle }) =>
    pillStyle &&
    css`
      font-size: 0.875rem !important;
      line-height: 16px;
      font-weight: 500 !important;
      text-transform: capitalize;
      color: #6b7280 !important;
      position: relative;
      padding: 8px 16px !important;
      border-radius: 4px !important;
      border: none !important;
      background-color: transparent !important;
      width: 100%;
      text-align: center !important;
      cursor: pointer;
      transition: all 0.2s ease;
      margin: 0 2px;

      &:hover {
        background-color: #f3f4f6 !important;
        color: #374151 !important;
      }

      &:first-child {
        margin-left: 0;
      }

      &:last-child {
        margin-right: 0;
      }

      &:after {
        display: none !important;
      }

      ${({ active }) =>
        active &&
        css`
          background-color: #16a34a !important;
          color: white !important;
          font-weight: 600 !important;
          border-bottom: none !important;

          &:hover {
            background-color: #15803d !important;
            color: white !important;
          }

          &:after {
            display: none !important;
            visibility: hidden !important;
            opacity: 0 !important;
            width: 0 !important;
          }
        `}
    `}
`;

export const StyledTabPanels = styled.div`
  /* overflow: hidden; */
  padding: 16px 0 0 0;

  @media (min-width: 768px) {
    padding: 20px 0 0 0;
  }
`;

export const StyledTabPanel = styled.div`
  position: relative;
  padding-left: 15px;
  width: 100%;
  opacity: 0;
  visibility: hidden;
  height: 0;
  ${'' /* transition: all 0.3s ease-in-out; */}

  ${({ active }) =>
    active &&
    css`
      opacity: 1;
      visibility: visible;
      height: auto;
    `}
`;

export const Wrap = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  width: 100%;
  height: auto;
  padding: 0;
  border: none;
  position: relative;

  &::-webkit-scrollbar {
    height: 8px;
    border-radius: 0;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 5px;
  }
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.3);
  }
`;

export const StyledTabs = styled.div`
  display: flex;
  margin: 0;
  box-sizing: inherit;

  ${({ verticalTabs, pillStyle }) =>
    verticalTabs &&
    !pillStyle &&
    css`
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      gap: 20px;

      ${Wrap} {
        display: block;
        width: 250px;
        height: auto;
        padding: 0;
        overflow-y: auto;
        overflow-x: hidden;
        flex-shrink: 0;
      }

      ${StyledTabList} {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        white-space: normal;
        gap: 0;
        width: 100%;
        height: auto;
        padding: 0;
        overflow: visible;
        margin: 0;
        background: transparent;
        border: none;
        box-shadow: none;
      }

      ${StyledTabPanel} {
        padding-left: 0;
      }

      ${StyledTabPanels} {
        padding: 0;
        flex: 1;
        min-width: 0;
      }
    `}

  ${({ verticalTabs, pillStyle }) =>
    verticalTabs &&
    pillStyle &&
    css`
      display: block;

      ${Wrap} {
        display: flex;
        align-items: center;
        width: 100%;
        height: auto;
        padding: 0;
        overflow-y: hidden;
        overflow-x: auto;
      }

      ${StyledTabList} {
        display: flex;
        align-items: center;
        white-space: nowrap;
        gap: 0;
        width: 100%;
        height: auto;
        padding: 0;
        overflow-y: hidden;
        margin: 0;
      }

      ${StyledTabPanel} {
        padding-left: 0;
      }
      ${StyledTabPanels} {
        padding: 10px 0;
      }
    `}
`;
